import { render, staticRenderFns } from "./SiblingCardItem.vue?vue&type=template&id=2f587ff2&scoped=true&"
import script from "./SiblingCardItem.vue?vue&type=script&lang=js&"
export * from "./SiblingCardItem.vue?vue&type=script&lang=js&"
import style0 from "./SiblingCardItem.vue?vue&type=style&index=0&id=2f587ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f587ff2",
  null
  
)

export default component.exports